import React from "react";
import { WidgetProps } from "@rjsf/core";
import { List } from "semantic-ui-react";
import PersonName, { PersonNameById } from "../../../../../sg-hpr/components/persons/PersonName";

export const PersonPickerDisplay: React.FC<WidgetProps> = ({ value: rawValue, formContext }) => {
    let value = rawValue
    if (!value) {
        return <p>{formContext.emptyValue}</p>
    }

    const { persons = {}, companies = {} } = formContext.data || {}

    const renderPerson = (personId: number) => {
        const person = persons[personId]
        const company = person && person.company ? companies[person.company] : null;

        if (!person || (person.company && !company)) {
            return (
                <PersonNameById key={personId} personId={personId} showCompany infoPopup showPhone={formContext.showPersonPhonenumber} />
            )
        }
        return (
            <PersonName key={personId} person={person} company={company} showCompany infoPopup showPhone={formContext.showPersonPhonenumber} />
        )
    }

    return (
        <div className="filled_value_container">
            <List>
                {Array.isArray(value) ? (
                    value.map((personId, index) => (
                        <List.Item key={personId} style={{ padding: "0.1em 0em" }}>
                            {personId ? renderPerson(personId) : null}
                        </List.Item>

                    ))) : value ? (
                        value ? renderPerson(value) : null
                    ) : formContext.emptyValue
                }
            </List>
        </div>

    )
};
